import { render, staticRenderFns } from "./FaviconForm.vue?vue&type=template&id=34ca1678&scoped=true"
import script from "./FaviconForm.vue?vue&type=script&lang=js"
export * from "./FaviconForm.vue?vue&type=script&lang=js"
import style0 from "./FaviconForm.vue?vue&type=style&index=0&id=34ca1678&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ca1678",
  null
  
)

export default component.exports